import getFormData from '@/util/form-data';
import httpClient from './http-client';

const endpoint = 'api/publications';

const publicationsService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  search: (query) => httpClient.get(`${endpoint}/find/${query}`),

  create: (publication) => httpClient.post(`${endpoint}`, publication),

  // update: (publication) => httpClient.put(`${endpoint}/${publication.id}`, publication),

  update: (publication) => {
    const fieldBlacklist = ['image'];

    const formData = getFormData(publication, fieldBlacklist);
    formData.append('_method', 'put');

    return httpClient.post(`${endpoint}/${publication.id}`, formData);
  },

  delete: (publication) => httpClient.delete(`${endpoint}/${publication.id}`),
};

export default publicationsService;
